export const olivioDesignOptions = [
	{
		id: 'sistema',
		model: 'Olivio',
		label: {
			de: 'Sistema',
			en: 'Sistema',
			fr: 'Sistema',
		},
		description: {
			de: 'Olivio Sistema ist besonders ausdrucksstark und setzt attraktive und sichtbare Akzente. Bei Olivio Sistema können die Leuchten zwischen 0° und 360° um den Mast herum angeordnet werden – auf einer oder auf unterschiedlichen Ebenen. Mit Masthöhen bis 12 m und drei verschiedenen Auslegertypen entsteht ein großer Gestaltungsspielraum.',
			en: 'Olivio Sistema is particularly expressive and creates attractive, highly visible accents. The luminaires in the Olivio Sistema can be arranged anywhere from 0° to 360° around the pole—either on a single level or across different levels. With pole heights of up to 12 meters and three different types of mounting arms, it offers a wide range of design possibilities.',
			fr: 'Olivio Sistema est particulièrement expressif et crée des accents attrayants et bien visibles. Les luminaires du système Olivio peuvent être disposés à 360° autour du mât – soit sur un seul niveau, soit sur plusieurs niveaux. Avec des hauteurs de mât allant jusqu’à 12 mètres et trois types de consoles différents, il offre un large éventail de possibilités de conception.',
		},
		pole: {
			de: 'Olivio Sistema Systemmast konisch aus feuerverzinktem Stahl, feuerverzinkt, pulverbeschichtet, bündig eingelassene Masttür, Türverschluss Dreikant 10mm',
			en: 'Olivio Sistema system pole tapered made of hot dipped galvanised steel, hot-dipped galvanised, powder-coated, flush door, triangular door lock 10mm',
			fr: 'Ensemble Sistema rétreint en acier galvanisé à chaud, galvanisé à chaud, thermolaquage poudre, flush door, triangular door lock 10mm',
		}
	},
	{
		id: 'floracion',
		model: 'Olivio',
		label: {
			de: 'Floracion',
			en: 'Floracion',
			fr: 'Floracion',
		},
		description: {
			de: 'Olivio Floracion wirkt floral und lebendig. Diese elegante Designlinie der Olivio inspiriert, ohne sich zu sehr in den Vordergrund zu drängen. Bei der Olivio Floracion sind Mast und Leuchten direkt miteinander kombiniert. Der eigenständige Charakter wird durch verschiedene Anordnungsvarianten der Leuchtenköpfe unterstrichen.',
			en: 'Olivio Floracion has a floral and vibrant appearance. This elegant design line of the Olivio range is inspiring without being overly dominant. In the Olivio Floracion, the pole and luminaires are directly integrated. Its distinctive character is emphasized by various arrangement options for the luminaire heads.',
			fr: 'Olivio Floracion présente une apparence florale et dynamique. Cette ligne de design élégante de la gamme Olivio inspire sans jamais s’imposer. Dans Olivio Floracion, le mât et les luminaires sont directement intégrés. Son caractère distinctif est renforcé par différentes possibilités d’agencement des têtes de luminaires.',
		},
		pole: {
			de: 'Olivio Floracion Systemmast zylindrisch aus feuerverzinktem Stahl, pulverbeschichtet, bündig eingelassene Masttür, Türverschluss Dreikant 10mm, mit Bodenplatte',
			en: 'Olivio Floracion system pole cylindrical made of hot dipped galvanised steel, powder-coated, flush door, triangular door lock 10mm, with base plate',
			fr: 'Ensemble Floracion tubulaire en acier galvanisé à chaud, thermolaquage poudre, flush door, triangular door lock 10mm, avec semelle d\'entraxe 300x300mm',
		}
	},
	{
		id: 'candelabra',
		model: 'Olivio',
		label: {
			de: 'Candelabra',
			en: 'Candelabra',
			fr: 'Candelabra',
		},
		description: {
			de: 'Olivio Candelabra ist die zurückhaltendste Designlinie innerhalb der Olivio Leuchtenfamilie. Einfach, zweifach oder dreifach: Auch die Olivio Candelabra lässt sich, basierend auf einer Kombination von Mast und Leuchtenkopf, in unterschiedlichen Varianten anordnen.',
			en: 'Olivio Candelabra is the most understated design line within the Olivio luminaire family. Whether single, double, or triple: Olivio Candelabra can also be configured in various versions, based on a combination of pole and luminaire head.',
			fr: 'Olivio Candelabra est la ligne de design la plus discrète de la famille de luminaires Olivio. Qu’elle soit simple, double ou triple, Olivio Candelabra peut également être configurée en différentes versions, grâce à une combinaison de mât et de tête de luminaire.',
		},
		pole: {
			de: 'Olivio Candelabra Systemmast konisch',
			en: 'Olivio Candelabra system pole tapered',
			fr: 'Olivio Candelabra mât système conique',
		}
	},

	/*
	{
		id: 'bollard',
		model: 'OlivioBollard',
		label: {
			de: 'Poller',
			en: 'Bollard',
			fr: 'Bollard',
		},
		description: {
			de: 'Olivio Poller. Die Vielfalt an Möglichkeiten schafft Gestaltungsfreiheit für funktionale und ästhetische Lichtlösungen.',
			en: 'Olivio bollard. The wide range of options provides creative freedom for functional and aesthetic lighting solutions.',
			fr: 'Olivio bollard. La variété des possibilités offre une liberté de conception pour des solutions d’éclairage fonctionnelles et esthétiques.',
		},
		pole: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'universal',
		model: 'OlivioUniversal',
		label: {
			de: 'Universal',
			en: 'Universal',
			fr: 'Universal',
		},
		description: {
			de: 'Olivio Wand- oder Bodenleuchte. Die Vielfalt an Möglichkeiten schafft Gestaltungsfreiheit für funktionale und ästhetische Lichtlösungen.',
			en: 'Olivio wall or floor luminaire. The wide range of options provides creative freedom for functional and aesthetic lighting solutions.',
			fr: 'Luminaire mural ou sur pied Olivio. La variété des possibilités offre une liberté de conception pour des solutions d’éclairage fonctionnelles et esthétiques.',
		},
		pole: {
			de: '',
			en: '',
			fr: '',
		}
	},
 	*/
];
export const olivioSistemaPoleHeightOptions = [5, 6, 7, 8, 9, 10, 11, 12].map((num) =>
	({
		id: num + '',
		meter: num,
		label: {
			de: num + 'm',
			en: num + 'm',
			fr: num + 'm',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		number: ['SX 160 05-9', 'SX 160 06-9', 'SX 160 07-9', 'SX 160 08-9', 'SX 160 09-9', 'SX 160 10-9', 'SX 160 11-9', 'SX 160 12-9'][num - 5],
		price: [null, null, null, null, null, null, null, null][num - 7],
		// price: [null, 3380, 3584, 3789, 3994, 4199, null, null][num - 7],
		diameter: num <= 9 ?  89 : 109
	}));
export const olivioFloracionPoleHeightOptions = [5, 6, 7, 8, 9, 10, 11, 12].map((num) =>
	({
		id: num + '',
		meter: num,
		label: {
			de: num + 'm',
			en: num + 'm',
			fr: num + 'm',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		number: ['SX 161 05-9', 'SX 161 06-9', 'SX 161 07-9', 'SX 161 08-9', 'SX 161 09-9', 'SX 161 10-9', 'SX 161 11-9', 'SX 161 12-9'][num - 5],
		price: [3226, 3636, 4045, 4455, 4864, 5274, 5684, 6093][num - 5],
		diameter: {
			OlivioGrande: 219,
			OlivioMedio: 219,
			OlivioPiccolo: 139,
		}
	}));
export const olivioFloracionWoodCylindricalPoleHeightOptions = [3, 4, 5, 6, 7].map((num) =>
	({
		id: num + '',
		meter: num,
		label: {
			de: num + 'm',
			en: num + 'm',
			fr: num + 'm',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		number: '',
		price: null,
		diameter: null
	}));
export const olivioFloracionPoleDiameterOptions = [140, 168, 220].map((num) =>
	({
		id: num + '',
		diameter: num,
		label: {
			de: num + 'mm',
			en: num + 'mm',
			fr: num + 'mm',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	}));
export const olivioCandelabraPoleHeightOptions = [3.5, 4.5].map((num) =>
	({
		id: num + '',
		meter: num,
		label: {
			de: num + 'm',
			en: num + 'm',
			fr: num + 'm',
		},
		description: {
			de: 'Candelabra Systemmast konisch, Höhe: ' + num + 'm',
			en: 'Candelabra Systemmast pole, Height: ' + num + 'm',
			fr: 'Candelabra Ritma mât système conique, hauteur: ' + num + 'm',
		},
		number: {
			3.5: '3',
			4.5: '4'
		},
		price: {
			3.5: null,
			4.5: null
		},
		diameter: 60
	}));

export const olivioBollardPoleHeightOptions = [
	{
		id: '1',
		meter: 1,
		label: {
			de: 'Picollo (1 m)',
			en: 'Picollo (1 m)',
			fr: 'Picollo (1 m)'
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: '1.2',
		meter: 1.2,
		label: {
			de: 'Medio (1.2 m)',
			en: 'Medio (1.2 m)',
			fr: 'Medio (1.2 m)'
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	}
];
export const olivioNumberOfHeadsOptions = [1, 2, 3, 4, 5, 6, 7, 8].map((num) =>
	({
		id: num + '',
		number: num,
		label: {
			de: num + '',
			en: num + '',
			fr: num + '',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	}));
export const olivioPoleMaterialOptions = [
	{
		id: 'steel',
		label: {
			de: 'Stahl zylindrisch',
			en: 'Steel cylindrical',
			fr: 'acier cylindrique',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'wood_cylindrical',
		label: {
			de: 'Holz zylindrisch',
			en: 'Wood cylindrical',
			fr: 'en bois cylindrique',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'wood_conical',
		label: {
			de: 'Holz konisch',
			en: 'Wood conical',
			fr: 'en bois conique',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	}
];
export const olivioWoodTypeOptions = [
	{
		id: 'redwood',
		label: {
			de: 'Redwood',
			en: 'Redwood',
			fr: 'Redwood',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'cool-scandinavian',
		label: {
			de: 'Cool Scandinavian',
			en: 'Cool Scandinavian',
			fr: 'Cool Scandinavian',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'canadian-brown',
		label: {
			de: 'Canadian Brown',
			en: 'Canadian Brown',
			fr: 'Canadian Brown',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'himalaya-grey',
		label: {
			de: 'Himalaya Grey',
			en: 'Himalaya Grey',
			fr: 'Himalaya Grey',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'rocky-mountain-grey',
		label: {
			de: 'Rocky Mountain Grey',
			en: 'Rocky Mountain Grey',
			fr: 'Rocky Mountain Grey',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'teneriffa-grey',
		label: {
			de: 'Teneriffa Grey',
			en: 'Teneriffa Grey',
			fr: 'Teneriffa Grey',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	}
];
export const olivioBracketOptions = [
	{
		id: 'sistema1',
		label: {
			de: 'Sistema 1',
			en: 'Sistema 1',
			fr: 'Sistema 1',
		},
		description: {
			de: 'Olivio Sistema Ausleger 1, 1-fach, aus Aluminium-Guss, pulverbeschichtet, Gewicht: 2,2 kg',
			en: 'Olivio Sistema 1 bracket, single, made of cast aluminium, powder-coated, Weight: 2,2 kg',
			fr: 'Console Olivio Sistema 1, simple, en fonderie d\'aluminium, peinture poudre, poids: 2,2kg'
		},
		number: 'SX 97-514-9',
		price: 337
	},
	{
		id: 'sistema2',
		label: {
			de: 'Sistema 2',
			en: 'Sistema 2',
			fr: 'Sistema 2',
		},
		description: {
			de: 'Olivio Sistema Ausleger 2, 1-fach, aus Aluminium-Guss, pulverbeschichtet Gewicht: 1,6 kg',
			en: 'Olivio Sistema 2 bracket, single, made of cast aluminium, powder-coated, Weight: 1,6 kg',
			fr: 'Console Olivio Sistema 2, simple, en fonderie d\'aluminium, peinture poudre, poids: 1,6kg',
		},
		number: 'SX 97-515-9',
		price: 312
	},
	{
		id: 'sistema3',
		label: {
			de: 'Sistema 3',
			en: 'Sistema 3',
			fr: 'Sistema 3',
		},
		description: {
			de: 'Olivio Sistema Ausleger 3, 1-fach, aus Aluminium-Guss, pulverbeschichtet, Gewicht: 0,33 kg',
			en: 'Olivio Sistema 3 bracket, single, made of cast aluminium, powder-coated, Weight: 0,33 kg',
			fr: 'Patin Olivio 200/300, simple, en fonderie d\'aluminium, peinture poudre, poids: 0,33kg',
		},
		number: {
			OlivioGrande: 'SX 97-551-9',
			OlivioMedio: 'SX 97-551-9',
			OlivioPiccolo: 'SX 97-552-9'
		},
		price: {
			OlivioGrande: 150,
			OlivioMedio: 150,
			OlivioPiccolo: 142
		}
	},
];
export const olivioCandelabraTopOptions = [
	{
		id: '1.000',
		label: {
			de: 'Ein Lichtpunkt',
			en: 'One Luminaire',
			fr: 'One Luminaire',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		number: '0',
		angles: [0]
	},
	{
		id: '2.120',
		label: {
			de: 'Zwei Lichtpunkte (120°)',
			en: 'Two Luminaires (120°)',
			fr: 'Two Luminaires (120°)',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		number: '1',
		angles: [0, 120]
	},
	{
		id: '2.180',
		label: {
			de: 'Zwei Lichtpunkte (180°)',
			en: 'Two Luminaires (180°)',
			fr: 'Two Luminaires (180°)',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		number: '3',
		angles: [0, 180]
	},
	{
		id: '3.000',
		label: {
			de: 'Drei Lichtpunkte',
			en: 'Three Luminaires',
			fr: 'Three Luminaires',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		number: '2',
		angles: [0, 120, 240]
	},
];
export const olivioHousingSizeOptions = [
	{
		id: 'OlivioGrande',
		label: {
			de: 'Olivio Grande',
			en: 'Olivio Grande',
			fr: 'Olivio Grande',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'OlivioMedio',
		label: {
			de: 'Olivio Medio',
			en: 'Olivio Medio',
			fr: 'Olivio Medio',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'OlivioPiccolo',
		label: {
			de: 'Olivio Piccolo',
			en: 'Olivio Piccolo',
			fr: 'Olivio Piccolo',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
];

export const olivioHeadHousingSizeOptions = [
	{
		id: 'OlivioGrande',
		label: {
			de: 'Olivio Grande',
			en: 'Olivio Grande',
			fr: 'Olivio Grande',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'OlivioMedio',
		label: {
			de: 'Olivio Medio',
			en: 'Olivio Medio',
			fr: 'Olivio Medio',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'OlivioPiccolo',
		label: {
			de: 'Olivio Piccolo',
			en: 'Olivio Piccolo',
			fr: 'Olivio Piccolo',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
];
export const olivioHeadColourTemperatureOptions = [
	{
		id: '2200K',
		label: {
			de: '2200 K',
			en: '2200 K',
			fr: '2200 K',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: '2700K',
		label: {
			de: '2700 K',
			en: '2700 K',
			fr: '2700 K',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: '3000K',
		label: {
			de: '3000 K',
			en: '3000 K',
			fr: '3000 K',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: '4000K',
		label: {
			de: '4000 K',
			en: '4000 K',
			fr: '4000 K',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'RGBW',
		label: {
			de: 'RGBW',
			en: 'RGBW',
			fr: 'RGBW',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
];

export const olivioHeadTypeOptions = [
	{
		id: 'luminaire',
		label: {
			de: 'Luminaire',
			en: 'luminaire',
			fr: 'luminaire',
		},
		info: {
			de: '',
			en: '',
			fr: '',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'gobo',
		label: {
			de: 'Gobo Projektor',
			en: 'Gobo Projector',
			fr: 'Gobo Projecteur',
		},
		info: {
			de: 'rotationssymmetrisch, Abstrahlwinkel anpassbar, LED, 6500 K, 49 W',
			en: 'rotation symmetrical, beam angle adjustable, LED, 6500 K, 49 W',
			fr: 'rotation symétrique, projection d\'image fixe, LED, 6500K, 49W',
		},
		description: {
			de: 'Gobo-Projektor (Projektionstechnik von Derksen), Leuchtengehäuse aus Aluminium-Druckguss, lackiert, Aluminium, Edelstahl, Schrauben Edelstahl, einstellbares Kopfgelenk sichert präzise Ausrichtung des Leuchtenkopfes, weiter Neigungsbereich von 20° bis 195°, + / - 180° drehbar, Abdeckung aus Sicherheitsglas, aktive Kühlung, unsichtbare Kabelführung durch das Kopfgelenk',
			en: 'Gobo projector (projection technology by Derksen), luminaire housing made of die-cast aluminium, painted, aluminium, Stainless steel, screws made of stainless steel, adjustable head joint ensures precise direction of luminaire head, wide tilt range from 20° to 195°, can be rotated + / - 180°, shielding made of safety glass, active cooling, hidden cable entry through the head joint',
			fr: 'Projecteur d\'image à focale fixe, refroidissement par convection forcée · Corps du luminaire en fonderie d\'aluminium · acier inoxydable · vis en acier inoxydable · inclinable de +/- 90° par pas de 5°, orientable sur 360° · fermeture en verre trempé, à utiliser avec la lentille à focale adaptée à la projection souhaitée · pour gobo verre de diamètre 50mm au motif de diamètre 40mm'
		},
		number: 'SX 960 90-9',
		price: 3445
	},
	{
		id: 'camera',
		label: {
			de: 'Kamera',
			en: 'Camera',
			fr: 'Camera',
		},
		info: {
			de: 'Olivio Grande Gehäuse für Kamera',
			en: 'Olivio Grande Housing for Camera',
			fr: 'Olivio Grande caméra logement',
		},
		description: {
			de: 'Olivio Grande Gehäuse für Kamera, zur Montage an Systemlichtmaste, Leuchtengehäuse aus Aluminium-Druckguss, lackiert, Aluminium, Schrauben Edelstahl, einstellbares Kopfgelenk sichert präzise Ausrichtung des Leuchtenkopfes, weiter Neigungsbereich von 20° bis 195°, + / - 180° drehbar',
			en: 'Olivio Grande Housing for Camera, to be mounted on system poles, luminaire housing made of die-cast aluminium, painted, aluminium, screws made of stainless steel, adjustable head joint ensures precise direction of luminaire head, wide tilt range from 20° to 195°, can be rotated + / - 180°',
			fr: 'Corps du luminaire en fonderie d\'aluminium · vis en acier inoxydable · inclinable de +/- 90° par pas de 5°, orientable sur 360° · pour installation sur mâts · entrée de câble masquée',
		},
		number: 'SX 960 85-9',
		price: 1291
	},
	{
		id: 'speaker',
		label: {
			de: 'Lautsprecher',
			en: 'Speaker',
			fr: 'Speaker',
		},
		info: {
			de: 'Lautsprecher, FR 16 WP 4 Ohm, 60Hz bis 15000Hz, 86dB',
			en: 'Speaker, FR 16 WP 4 Ohm, 60Hz to 15000Hz, 86dB',
			fr: 'Speaker, FR 16 WP 4 Ohm, 60Hz to 15000Hz, 86dB',
		},
		description: {
			de: 'Lautsprecher, Gehäuse aus Aluminium-Druckguss, Schrauben Edelstahl für den Einsatz in einem ELA-Anlagen-System, ein FR 16 WP 4 Ohm Lautsprecher, 100V-Transformer TR 84, ' +
				'Übertragungsbereich: 60Hz bis 15000Hz, mittlerer Schalldruckpegel: 86dB, Abstrahlwinkel: (-6dB) 46°/4000Hz, Temperaturbereich: -40 ... 80°C',
			en: 'Speaker, housing made of die-cast aluminium, screws made of stainless steel for use in a electro-acoustic system (ELA), one FR 16 WP 4 Ohm loudspeaker, 100V-transformer TR 84, ' +
				'Frequency response: 60Hz to 15000Hz, Mean sound pressure level: 86dB, Opening angle: (-6dB) 46°/4000Hz, Temperature range: -40 ... 80°C',
			fr: 'Speaker, housing made of die-cast aluminium, screws made of stainless steel for use in a electro-acoustic system (ELA), one FR 16 WP 4 Ohm loudspeaker, 100V-transformer TR 84, ' +
				'Frequency response: 60Hz to 15000Hz, Mean sound pressure level: 86dB, Opening angle: (-6dB) 46°/4000Hz, Temperature range: -40 ... 80°C',
		},
		number: {
			OlivioGrande: 'SX 960 80-9',
			OlivioMedio: 'SX 961 80-9',
			OlivioPiccolo: 'SX 962 80-9'
		},
		price: {
			OlivioGrande: 1261,
			OlivioMedio: 984,
			OlivioPiccolo: 542
		}
	},
];
export const olivioHeadGoboApertureOptions = [
	{
		id: 'extrawide',
		label: {
			de: 'Extraweitwinkel',
			en: 'extra-wide-angle',
			fr: 'très grande angle',
		},
		info: {
			de: 'Brennweite: 45 mm',
			en: 'focal lenght: 45 mm',
			fr: 'distance focale: 45 mm',
		},
		description: {
			de: 'Extraweitwinkelobjektiv, Objektiv einfach austauschbar, Höhe H: 81 mm, Durchmesser Ø: 51,8 mm, Brennweite: 45 mm',
			en: 'extra-wide-angle lens, objective lens can be replaced easily, Height H: 81 mm, Diameter Ø: 51,8 mm, focal lenght: 45 mm',
			fr: 'lentille très grande angle f:150mm, remplacement simple et rapide de la objektif, Hauteur H: 81 mm, Diamètre Ø: 51,8 mm, distance focale: 45 mm',
		},
		number: 'SX 97-603-0',
		price: 500
	},
	{
		id: 'wide',
		label: {
			de: 'Weitwinkel',
			en: 'wide-angle',
			fr: 'grande angle',
		},
		info: {
			de: 'Brennweite: 63 mm',
			en: 'focal lenght: 63 mm',
			fr: 'distance focale: 63 mm',
		},
		description: {
			de: 'Weitwinkelobjektiv, Objektiv einfach austauschbar, Höhe H: 52 mm, Durchmesser Ø: 51,8 mm, Brennweite: 63 mm',
			en: 'wide-angle lens, objective lens can be replaced easily, Height H: 52 mm, Diameter Ø: 51,8 mm, focal lenght: 63 mm',
			fr: 'lentille grande angle f:150mm, remplacement simple et rapide de la objektif, Hauteur H: 52 mm, Diamètre Ø: 51,8 mm, distance focale: 63 mm',
		},
		number: 'SX 97-602-0',
		price: 256
	},
	{
		id: 'normal',
		label: {
			de: 'Standard',
			en: 'standard',
			fr: 'standard',
		},
		info: {
			de: 'Brennweite: 85 mm',
			en: 'focal lenght: 85 mm',
			fr: 'distance focale: 85 mm',
		},
		description: {
			de: 'Standardobjektiv, Objektiv einfach austauschbar, Höhe H: 52 mm, Durchmesser Ø: 51,8 mm, Brennweite: 85 mm',
			en: 'standard lense, objective lens can be replaced easily, Height H: 52 mm, Diameter Ø: 51,8 mm, focal lenght: 85 mm',
			fr: 'lentille standard f:150mm, remplacement simple et rapide de la objektif, Hauteur H: 52 mm, Diamètre Ø: 51,8 mm, distance focale: 85 mm',
		},
		number: 'SX 97-600-0',
		price: 225
	},
	{
		id: 'long',
		label: {
			de: 'Tele',
			en: 'telephoto',
			fr: 'telephoto',
		},
		info: {
			de: 'Brennweite: 150 mm',
			en: 'focal lenght: 150 mm',
			fr: 'distance focale: 150 mm',
		},
		description: {
			de: 'Teleobjektiv, Objektiv einfach austauschbar, Höhe H: 64 mm, Durchmesser Ø: 51,8 mm, Brennweite: 150 mm',
			en: 'telephoto lense, objective lens can be replaced easily, Height H: 64 mm, Diameter Ø: 51,8 mm, focal lenght: 150 mm',
			fr: 'lentille telephoto f:150mm, remplacement simple et rapide de la objektif, Hauteur H: 64 mm, Diamètre Ø: 51,8 mm, distance focale: 150 mm',
		},
		number: 'SX 97-601-0',
		price: 396
	}
];

export const olivioBaseOptions = [
	{
		id: 'buriedbase',
		label: {
			de: 'durchgehendes Erdstück',
			en: 'Buried base',
			fr: 'enfouissement',
		},
		description: {
			de: 'durchgehendes Erdstück',
			en: 'Buried base',
			fr: 'enfouissement',
		},
		number: '',
	},
	{
		id: 'FlangePlateDE',
		label: {
			de: 'Flanschplatte 240 (Typ DE)',
			en: 'Flange Plate 240 (Type DE)',
			fr: 'semelle 240x240 mm',
		},
		description: {
			de: 'Flanschplatte 240 (Typ DE)',
			en: 'Flange Plate 240 (Type DE)',
			fr: 'semelle 240x240 mm',
		},
		number: '',
	},
	{
		id: 'FlangePlateFRsmall',
		label: {
			de: 'Flanschplatte 200 (Typ FR)',
			en: 'Flange Plate 200 (Type FR)',
			fr: 'semelle entraxe 200x200 mm',
		},
		description: {
			de: 'Flanschplatte 200 (Typ FR)',
			en: 'Flange Plate 200 (Type FR)',
			fr: 'semelle entraxe 200x200 mm',
		},
		number: '',

	},
	{
		id: 'FlangePlateFR',
		label: {
			de: 'Flanschplatte 300 (Typ FR)',
			en: 'Flange Plate 300 (Type FR)',
			fr: 'semelle entraxe 300x300 mm',
		},
		description: {
			de: 'Flanschplatte 300 (Typ FR)',
			en: 'Flange Plate 300 (Type FR)',
			fr: 'semelle entraxe 300x300 mm',
		},
		number: '',
	},
];

export const olivioSeparateBuriedBaseOptions = [
	{
		id: 'none',
		label: {
			de: 'nein',
			en: 'none',
			fr: 'aucun'
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		number: '',
	},
	{
		id: 'separateBuriedBase',
		label: {
			de: 'separates Erdstück',
			en: 'separate base',
			fr: 'pièce de terre séparée',
		},
		description: {
			de: 'separates Erdstück',
			en: 'separate base',
			fr: 'pièce de terre séparée',
		},
		poleHeights: {
			5: {
				height: 1600,
				number: 'SX 97-051-0',
				price: 883
			},
			6: {
				height: 1600,
				number: 'SX 97-051-0',
				price: 883
			},
			7: {
				height: 1600,
				number: 'SX 97-051-0',
				price: 883
			},
			8: {
				height: 1600,
				number: 'SX 97-051-0',
				price: 883
			},
			9: {
				height: 1800,
				number: 'SX 97-055-0',
				price: 1267
			},
			10: {
				height: 1800,
				number: 'SX 97-055-0',
				price: 1267
			},
			11: {
				height: 1800,
				number: 'SX 97-055-0',
				price: 1267
			},
			12: {
				height: 2005,
				number: 'SX 97-056-0',
				price: 1395
			}
		},
	}
];
export const olivioSecondDoorOptions = [
	{
		id: 'none',
		label: {
			de: '1 Masttür',
			en: '1 Pole Door',
			fr: '1 porte de mât',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		designs: {
			sistema: {
				de: 'Höhe der Unterkante: 600mm; Größe 500mm x 85mm',
				en: 'Height of lower edge : 600mm; Size 500mm x 85mm',
				fr: 'Höhe Unterkante: 600mm; Taille 500mm x 85mm'
			},
			floracion: {
				de: 'Höhe der Unterkante: 600mm; Größe 400mm x 85mm',
				en:  'Height of lower edge: 600mm; Size 400mm x 85mm',
				fr:  'Hauteur du bord inférieur: 600mm; Taille 400mm x 85mm',
			},
			candelabra: {
				de: 'Höhe der Unterkante: 600mm; Größe: 400mm x 75mm',
				en: 'Height of lower edge: 600mm; Size 400mm x 75mm',
				fr: 'Hauteur du bord inférieur: 600mm; Taille 400mm x 75mm',
			},
		}
	},
	{
		id: 'secondDoor',
		label: {
			de: '2 Masttüren',
			en: '2 Pole Doors',
			fr: '2 porte de mât',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		designs: {
			sistema: {
				de: 'Höhe der Unterkante Tür 1: 600 mm, Tür 2: 1200mm; Größe 500 mm x 85 mm',
				en: 'Height of lower edge of door 1: 600 mm, Door 2: 1200mm; Size 500 mm x 85 mm',
				fr: 'Hauteur du bord inférieur de la porte 1: 600 mm, porte 2: 1200 mm; Taille 500 mm x 85 mm'
			},
			floracion: {
				de: 'Höhe der Unterkante Tür 1: 600 mm, Tür 2: 1100mm; Größe 400 mm x 85 mm',
				en:  'Height of lower edge of door 1: 600 mm, Door 2: 1100mm; Size 400 mm x 85 mm',
				fr:  'Hauteur du bord inférieur de la porte 1: 600 mm, porte 2: 1100 mm; Taille 400 mm x 85 mm',
			},
			candelabra: {
				de: 'Höhe der Unterkante Tür 1: 600 mm; Größe: 400 mm x 75 mm',
				en: 'Height of lower edge of door 1: 600 mm; Size: 400 mm x 75 mm',
				fr: 'Hauteur du bord inférieur de la porte 1: 600 mm; Taille: 400 mm x 75 mm',
			},
		}
	}
];
export const olivioFuseBoxOptions = [
	{
		id: 'none',
		label: {
			de: 'nein',
			en: 'none',
			fr: 'aucun'
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		number: '',
	},
	{
		id: 'fusebox',
		label: {
			de: 'Kabelsicherungskasten',
			en: 'fuse box',
			fr: 'boitier fusible',
		},
		description: {
			de: 'Kabelsicherungskasten IP55 zur bauseitigen Montage, 2x5x6mm² für Durchgangsverdrahtung, Schutzklasse II',
			en: 'IP55 fuse box for site mounting, 2x5x6mm² for through-wiring, Protection Class II',
			fr: 'boitier fusible IP55 pour montage sur site, pour passage en coupure 2x5x6mm², classe électrique 2',
		},
		number: 'SX 97-030-0',
		price: 115
	}
];
export const olivioBuriedBaseSizeOptions = [800, 1000, 1200, 1500, 2000].map((num) =>
	({
		id: num + '',
		size: num,
		label: {
			de: num + 'mm',
			en: num + 'mm',
			fr: num + 'mm',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	}));
